import React from "react";
import TopBanner from "../components/banner/topBanner";
import { Banners } from "../components/data";

export default function Sklad() {
    return(
        <div className="Sklad">
            <TopBanner title={Banners[4].title} />
            <div className="container">
                <p className="text-center textSklad">
                    Система взаимодействует в режиме реального времени с базой данных, чтобы уменьшить количество ошибок при получении заказов, в то время как мобильный сканер штрихкодов проверяет заказы, предупреждает пользователей о несоответствиях, создает этикетки товаров по требованию, фиксирует номера продуктов
                </p>
            </div>
        </div>
    )
}